import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const hasToken = typeof window !== "undefined" && localStorage.getItem("ss_token");
    const hasCookie = typeof document !== "undefined" && document.cookie.includes("access_token");
    if (!hasToken && !hasCookie) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("ss_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("ss_token");
    setUser(false);
  };

  const registerStaff = async (payload) => {
    const { data } = await api.post("/auth/register-staff", payload);
    if (data.access_token) localStorage.setItem("ss_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const registerCompany = async (payload) => {
    const { data } = await api.post("/auth/register-company", payload);
    if (data.access_token) localStorage.setItem("ss_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, registerStaff, registerCompany, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
